/* Mutual Optical — header search dropdown: predictive results + recent searches + popular models. No app. */
(function () {
  var RKEY = 'mo_recent_searches';
  function getRecent() { try { return JSON.parse(localStorage.getItem(RKEY)) || []; } catch (e) { return []; } }
  function pushRecent(q) { q = (q || '').trim(); if (!q) return; var a = getRecent().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); }); a.unshift(q); try { localStorage.setItem(RKEY, JSON.stringify(a.slice(0, 6))); } catch (e) {} }
  function clearRecent() { try { localStorage.removeItem(RKEY); } catch (e) {} }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
  var SICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"></circle><path d="m21 21-4.3-4.3"></path></svg>';

  function initWrap(wrap) {
    var input = wrap.querySelector('[data-mo-search-input]');
    var panel = wrap.querySelector('[data-mo-search-panel]');
    var form = wrap.matches('form') ? wrap : wrap.querySelector('form');
    if (!input || !panel) return;
    var popular = (wrap.getAttribute('data-mo-popular') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    var timer = null;

    function open() { panel.hidden = false; }
    function close() { panel.hidden = true; }

    function termItem(q) {
      return '<a class="mo-srch__term" href="/search?q=' + encodeURIComponent(q) + '&type=product">' + SICON + '<span>' + esc(q) + '</span></a>';
    }
    function group(title, itemsHtml, withClear) {
      if (!itemsHtml) return '';
      var clr = withClear ? '<button type="button" class="mo-srch__clear" data-mo-clear>Clear</button>' : '';
      return '<div class="mo-srch__group"><div class="mo-srch__hd">' + title + clr + '</div>' + itemsHtml + '</div>';
    }

    function renderEmpty() {
      var recent = getRecent();
      var html = '';
      html += group('Recent Searches', recent.map(termItem).join(''), true);
      html += group('Popular Models', popular.map(termItem).join(''), false);
      panel.innerHTML = html || '<div class="mo-srch__empty">Start typing to search the catalog…</div>';
    }

    function renderResults(products, q) {
      if (!products.length) { panel.innerHTML = '<div class="mo-srch__empty">No matches for &ldquo;' + esc(q) + '&rdquo;.</div>'; return; }
      var items = products.map(function (p) {
        var img = p.image ? '<img src="' + p.image + '" alt="" loading="lazy">' : '<span class="mo-srch__ph"></span>';
        return '<a class="mo-srch__prod" href="' + p.url + '">' + img + '<span class="mo-srch__prodt">' + esc(p.title) + '</span></a>';
      }).join('');
      panel.innerHTML = '<div class="mo-srch__group">' + items + '</div>' +
        '<a class="mo-srch__all" href="/search?q=' + encodeURIComponent(q) + '&type=product">See all results for &ldquo;' + esc(q) + '&rdquo;</a>';
    }

    function suggest(q) {
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last')
        .then(function (r) { return r.json(); })
        .then(function (d) { var ps = (d.resources && d.resources.results && d.resources.results.products) || []; if (panel.hidden === false) renderResults(ps, q); })
        .catch(function () {});
    }

    input.addEventListener('focus', function () { open(); if (!input.value.trim()) renderEmpty(); });
    input.addEventListener('input', function () {
      var q = input.value.trim(); open(); clearTimeout(timer);
      if (!q) { renderEmpty(); return; }
      timer = setTimeout(function () { suggest(q); }, 180);
    });
    if (form) form.addEventListener('submit', function () { pushRecent(input.value); });
    panel.addEventListener('click', function (e) {
      var c = e.target.closest ? e.target.closest('[data-mo-clear]') : null;
      if (c) { e.preventDefault(); clearRecent(); renderEmpty(); }
      var link = e.target.closest ? e.target.closest('a') : null;
      if (link) pushRecent(input.value);
    });
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape') { close(); input.blur(); } });
    document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) close(); });
  }

  function init() { var ws = document.querySelectorAll('[data-mo-searchwrap]'); for (var i = 0; i < ws.length; i++) initWrap(ws[i]); }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();
